module.exports = __webpack_public_path__ + "media/images/clickworker_com/2fa_step_4-7194044d195f93efda55c1ecd86b4f08.png";